import { AxiosInstance } from "axios";

export async function downloadPropostaPdf(
  api: AxiosInstance,
  uuid: string,
  fileName = "proposta-digital.pdf",
): Promise<void> {
  const response = await api.get(
    `/utils/get-contract-pdf/${uuid}?portal=hub`,
    { responseType: "blob" },
  );

  const blob = new Blob([response.data], { type: "application/pdf" });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", fileName);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
}
